module.exports = __webpack_public_path__ + "img/henry-young.01087acd.jpg";